<template>
  <div>
    <div class="row">
      <div class="col-sm-3">
        <Datepicker :value="date" :language='fr'
          @selected="dateSelected"
          format='yyyy-MM-dd'></Datepicker>
      </div>
      <div class="col-sm-4">
        Utilisateurs dans les 30 dernières minutes: {{data.data.derniers_30_min}}
      </div>
      <div class="col-sm-5">
        <button class="btn btn-primary btn-sm float-right" v-on:click="refresh">Mettre à jour</button>
        <p style="padding: 8px 8px 0 0;" class="text-muted float-right">
          <small><em>Mise-à-jour automatique dans {{countdown}} secondes</em></small>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 graph-box">
        <QuinzeMinutes height=100 width=300 :data='data.data.quinzeminutes'></QuinzeMinutes>
      </div>
      <div class="col-sm-12 graph-box">
        <ListeUsagers :usagers='data.data.usagers'></ListeUsagers>
      </div>
    </div>
  </div>
</template>

<script>
import QuinzeMinutes from '@/components/QuinzeMinutes.vue';
import ListeUsagers from '@/components/ListeUsagers.vue';
import Datepicker from 'vuejs-datepicker';
import {fr} from 'vuejs-datepicker/dist/locale'
import axios from 'axios';
import moment from 'moment';

export default {
  data: function() {return {
    countdown: 59,
    polling: null,
    days: 45,
    date: new Date(),
    nextUpdate: {},
    fr: fr,
    data: {data: { quinzeminutes:{}, usagers:[] }}
  }},

  name: 'Aujourdhui',
  components: {
    Datepicker,
    QuinzeMinutes,
    ListeUsagers
  },
  methods: {
    dateSelected: function(newDate) {
      this.date=newDate;
      this.refresh()
    },
    intervalExpiry() {
      this.countdown--;
      if(this.countdown==0) {
        this.refresh(0);
        this.countdown=59;
      }
    },
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/aujourdhui.php',
          { params: {date: moment(this.date).format('YYYY-MM-DD')} })
        .then(response => (this.data = response));
    }
  },
  mounted () {
    this.refresh();
    this.polling = setInterval(function () {
      this.intervalExpiry();
    }.bind(this), 1000);
  },
  beforeDestroy () {
    clearInterval(this.polling)
  }
}
</script>

<style>
  div.graph {
    display: inline-block;
    width: 46%;
    background-color: #f5f5f5;
    border: 1px #c5c5c5 solid;
    border-radius: 5px;
    margin: 5px;
    padding: 15px;
  }
</style>
